import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useState, useContext } from 'react';
import { BallTriangle } from 'react-loader-spinner';
import { Context } from '../..';
import EventsService from '../../services/EventsService';
import { ModalPopover } from './modal/modal-popover';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';

const AnswerQuestion: FC<any> = (() => {

    return (
        <div className="w-100 h-100 p-0 position-relative end-0">
            <iframe src="https://help.happy59.com/" title="atlas100" className="w-100 h-100 border-0"/>
        </div>
    )
});

export default observer(AnswerQuestion);